import { render, staticRenderFns } from "./FormFieldInputNumberFormatted.vue?vue&type=template&id=523be28a&"
import script from "./FormFieldInputNumberFormatted.vue?vue&type=script&lang=ts&"
export * from "./FormFieldInputNumberFormatted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports